import type { Components, Theme } from '@mui/material';

const listItemButtonThemeConfig: Components<Theme>['MuiListItemButton'] = {
  styleOverrides: {
    root: {
      '&.Mui-selected': {
        background: 'rgba(33, 150, 243, 0.08)',
      },
    },
  },
};

export const muiListItemThemeConfig = {
  MuiListItemButton: {
    ...listItemButtonThemeConfig,
  },
};
